import React, { type ReactNode } from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./gridModule.module.css";

type GridModuleProps = {
    children: ReactNode;
    className?: string;
    isLastInColumn?: boolean;
};

export const GridModule = ({
    children,
    className,
    isLastInColumn,
}: GridModuleProps) => {
    const cx = createClasses([
        styles.gridModule,
        className,
        { [styles.isLastInColumn]: isLastInColumn },
    ]);

    return (
        <div className={cx} data-component="grid-module">
            {children}
        </div>
    );
};
